import script from "./AnimeNormal.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimeNormal.vue?vue&type=script&setup=true&lang=js"

import "./AnimeNormal.vue?vue&type=style&index=0&id=3a26158c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/website-app/website-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a26158c"]])

export default __exports__